import { getEventBus } from "@bossvn/core";
export const globalEventBus = getEventBus("app");
